/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
function handleVariantChange(event,productId,sectionId) {
  let current_form = event.target.closest("form");
  // let selectEl = document.getElementById(`ProductSelect_${productId}`);
  let selectEl = event.target;
  if (!selectEl) return;

  let selectedOption = selectEl.options[selectEl.selectedIndex];
  let price = selectedOption.getAttribute('data-price');
  let compare_at_price = selectedOption.getAttribute('data-compare-at-price') || '';

  let priceDiscountElement = current_form.querySelector(`#price-${productId}-discount`);
  if (priceDiscountElement) priceDiscountElement.textContent = price;

  let subscriptionPrice = current_form.querySelector(`#price-${productId}-subscription`);
  if (subscriptionPrice && compare_at_price) {
    subscriptionPrice.textContent = compare_at_price;
    subscriptionPrice.style.textDecoration = 'line-through';
  }

  let strikeElements = document.querySelectorAll(`.notoff_${productId}`);
  strikeElements.forEach(el => {
    if(compare_at_price!='')
    {
     el.textContent = compare_at_price; 
    }
  });

  let numericPrice = compare_at_price ? parseFloat(compare_at_price.replace(/[^0-9.]/g, '')) : 0;

  let onetimediscountElement = current_form.querySelector(".onetimediscount");
  let onetimediscount = onetimediscountElement ? parseFloat(onetimediscountElement.value) : 0;

  let discountPercentage = onetimediscount / 100;
  let discountPrice = numericPrice * (1 - discountPercentage);

  let formattedOriginalPrice = `$${numericPrice.toFixed(2)}`;
  let formattedDiscountPrice = `$${discountPrice.toFixed(2)}`;

  let originalPriceElements = document.querySelectorAll(`.original-price-strikethrough${productId}`);
  originalPriceElements.forEach(el => {
    el.textContent = formattedOriginalPrice;
  });

  let discountedPriceElements = document.querySelectorAll(`.discounted-price${productId}`);
  discountedPriceElements.forEach(el => {
    el.textContent = formattedDiscountPrice;
  });
}//function closed

function initProductFormToggle(event,productId,sectionId) {
  let openBtn  = document.querySelector(`.openform_${productId}_${sectionId}`);
  let productForm     = document.querySelector(`.thisform_${productId}_${sectionId}`);
  
  if (!openBtn || !productForm) return;
  
  productForm.style.display = "flex";
  openBtn.style.display = "none";
  
}//function closed

function closeProductForm(event, productId,sectionId) {

  let openBtn  = document.querySelector(`.openform_${productId}_${sectionId}`);
  let productForm     = document.querySelector(`.thisform_${productId}_${sectionId}`);
  
  if (!openBtn || !productForm) return;
  
  productForm.style.display = "none";
  openBtn.style.display = "inline-block";
  
}//function closed

function initSellingPlanSwitch(productId, sectionId, selectedValue) {
  
  let form = document.querySelector(`.thisform_${productId}_${sectionId}`);
  let detailsWrapper = form.querySelector(`.selling-plan-drop_${productId}`);
  let subRadio = form.querySelector(`.radio_subscription_${productId}`);
  let oneTimeRadio = form.querySelector(`.radio_buy_once_${productId}`);
  let discountBoxValue = document.body.getAttribute("data-discount-box");
  let apply_discount_field = form.querySelector(`#apply-discount-${productId}`);

  if (selectedValue === 'subscription') {
    detailsWrapper.classList.remove('hidden');
    detailsWrapper.querySelector('.delivery_options')?.removeAttribute('disabled');
    subRadio.setAttribute("checked","checked");
    oneTimeRadio.removeAttribute("checked");
    if(apply_discount_field){
      apply_discount_field.value = "false";
    }
  } else {
    detailsWrapper.classList.add('hidden');
    detailsWrapper.querySelector('.delivery_options')?.setAttribute('disabled', 'disabled');
    subRadio.removeAttribute("checked");
    oneTimeRadio.setAttribute("checked","checked");
    if(apply_discount_field){
     apply_discount_field.value = discountBoxValue; 
    }
  }
                        
}//function closed

